export default "__VITE_ASSET__a31d839a__"